import axios from "axios";
import { Toast } from "../../util/Toast";

import { ACCEPT_HOST_REQUEST, GET_HOST_REQUEST } from "./types";

export const getHostRequest = (id, type) => (dispatch) => {
  
  axios
    .get(`hostRequest/requestGetByAgency?agencyId=${id}&type=${type}`)
    .then((res) => {
      
      if (res.data.status) {
        dispatch({ type: GET_HOST_REQUEST, payload: res.data?.data });
      } else {
        Toast("error", res.message);
      }
    })
    .catch((error) => {
      Toast("error", error.message);
    });
};

export const acceptHostRequest = (id, type) => (dispatch) => {
  axios
    .patch(`hostRequest/acceptOrDecline?requestId=${id}&type=${type}` )
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ACCEPT_HOST_REQUEST,
          payload: id,
        });
        if (type === "declined") {
          Toast("success", "Decline Success!!");
        }
        if (type === "accept") {
          Toast("success", "Accept Success!!");
        }
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      Toast("error", error.message);
    });
};

// Accept a host request WITH a required Host Type (Audio Host / Video Host).
// Kept separate from acceptHostRequest so the decline flow above is untouched.
export const acceptHostRequestWithType = (id, hostType) => (dispatch) => {
  axios
    .patch(`hostRequest/acceptOrDecline?requestId=${id}&type=accept&hostType=${hostType}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ACCEPT_HOST_REQUEST,
          payload: id,
        });
        Toast("success", "Accept Success!!");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      Toast("error", error.message);
    });
};
